import React from 'react';
import { LayoutFooterContext } from '@/providers/LayoutFooterProvider';

export const useLayoutFooter = () => {
  const { height, useResizeEffect } = React.useContext(LayoutFooterContext);

  return { footerHeight: height, useFooterResizeEffect: useResizeEffect };
};
